module.exports = __webpack_public_path__ + "static/media/logo.7bb1b041.png";